// core version + navigation, pagination modules:
import Swiper, {
  Lazy, Navigation, Pagination, Autoplay
} from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const mySwiper = new Swiper('.js-main-slider', {
  loop: true,
  lazy: true,
  speed: 500,
  slidesPerView: 1,
  autoplay: {
    delay: 7000,
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

document.querySelectorAll('.js-product-slider').forEach((item) => {
  new Swiper(item, {
    loop: true,
    lazy: {
      loadPrevNext: true,
    },
    preloadImages: !1,
    slidesPerView: 1,
    spaceBetween: 17,
    centeredSlides: true,
    loopedSlides: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    },
  });
});


const adviceSlider = new Swiper('.js-advice-slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerGroup: 1,
  loop: true,
  lazy: true,
  loopFillGroupWithBlank: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
      spaceBetween: 0,
      slidesPerGroup: 3,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
      slidesPerGroup: 2,
    },
  },
});
